import {useSelector} from "react-redux";
import {ICartItem} from "@natomas-org/core";

export const useCartItem = (id?: string) => {
  return useSelector((state: any) => (!!id ? state.cart[id] : undefined)) as
    | ICartItem
    | undefined;
};
